import { fromIsoString } from '../chat/iso-date';
import type { SerializedWorkflowNode, WorkflowNodeData } from './types';
import { WorkflowNode, type WorkflowNodeHydration } from './workflow-node-base';
import { createWorkflowNode } from './workflow-nodes/create-workflow-node';

WorkflowNode.fromSerialized = (
  serialized: SerializedWorkflowNode,
  hydration: WorkflowNodeHydration
): WorkflowNode => {
  const data: WorkflowNodeData = {
    id: serialized.id,
    ownerId: serialized.ownerId,
    ownerOrgId: serialized.ownerOrgId,
    workflowId: serialized.workflowId,
    type: serialized.type,
    data: serialized.data,
    inputShape: serialized.inputShape,
    defaultOutput: serialized.defaultOutput,
    inputFromNodeId: serialized.inputFromNodeId ?? null,
    createdAt: fromIsoString(serialized.createdAt),
    updatedAt: fromIsoString(serialized.updatedAt),
  };
  return createWorkflowNode(data, hydration);
};
